module.exports = __webpack_public_path__ + "img/polymesh.7a9555a8.svg";